<template>
  <div class="component-container" v-if="isLoaded && isVisible">
    <h3 class="component-title">
      <span @click.prevent="()=>changeTagTab(type)">{{title}} <span class="dark-purple">{{totalCount}}</span></span>
      <span><NextButtonWhite /></span>
    </h3>
    <cell-list v-if="cellList && cellList.length"
               :cell-list="cellList"
               :thumbnail-info="thumbnailInfo"
               :container-class-name="getCellListContainerClassName"
    />
  </div>
</template>

<script>
import CellList from '@/components/section/template/cell/CellList'
import { getBandTypeInfoByCellType, getCellListContainerClassName } from '@/common/image.util'
import { get } from 'lodash'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
export default {
  name: 'TagSearchResultBand',
  components: {
    CellList,
    NextButtonWhite
  },
  data () {
    return {
      title: '',
      totalCount: 0,
      isLoaded: false,
      isVisible: false,
      cellType: '',
      cellList: [],
      thumbnailInfo: {}
    }
  },
  props: ['type', 'searchResult', 'changeTagTab'],
  computed: {
    getCellListContainerClassName () {
      return getCellListContainerClassName(this.thumbnailInfo.type)
    },
    hasViewMore () {
      return true
    }
  },
  created () {
    const cellType = get(this.searchResult, ['cell_toplist', 'cell_type'], '')
    this.cellType = cellType
    this.thumbnailInfo = getBandTypeInfoByCellType(cellType)
    this.cellList = get(this.searchResult, ['cell_toplist', 'celllist'], [])
    this.title = this.searchResult.title
    this.totalCount = get(this.searchResult, ['cell_toplist', 'totalcount'], 0)
  },
  mounted () {
    this.isLoaded = true
    this.isVisible = true
  }
}
</script>
